import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AUTH_CONFIG, AuthConfig, DEFAULT_SESSION_CONFIG, SessionConfig } from './auth-config-token';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Injectable, inject } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {

    private token: string = '';

    private readonly AUTH_HEADER: string = 'Authorization';

    private readonly config: AuthConfig = inject(AUTH_CONFIG);

    private readonly sessionConfig: SessionConfig = {
        ...DEFAULT_SESSION_CONFIG,
        ...(this.config.sessionConfig || {})
    };

    private readonly authService: AuthService = inject(AuthService);

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (!req.headers.has('Content-Type')) {
            req = req.clone({
                headers: req.headers.set('Content-Type', 'application/json'),
            });
        }

        req = this.addAuthenticationToken(req);

        return next
            .handle(req)
            .pipe(
                catchError((error: HttpErrorResponse) => {

                    if (error && error.status === 401) {
                        // 401 errors are most likely going to be because we have an expired token that we need to refresh.
                        this.authService.logout();
                    }
                    else {
                        // TODO error hnalder
                        console.error('HTTP Error:', error);
                    }

                    // return EMPTY;
                    return throwError(error); // TODO test if ok.
                })
            );
    }

    private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {

        // If we do not have a token yet then we should not set the header.
        // Here we could first retrieve the token from where we store it.
        if (!this.token) {
            return request;
        }

        // If its calling an outside domain then do not add the token.
        const isPublicUrl: boolean = Boolean(
            !request.url.match(new RegExp(`${API_BASE_URL}`))
            || this.sessionConfig.publicUrls?.some((url: string) => request.url.endsWith(url))
        );

        if (isPublicUrl) {
            return request;
        }

        return request.clone({
            headers: request.headers.set(
                this.AUTH_HEADER,
                this.authService.bearerToken
            ),
        });
    }
}
